/**
 * Single Source of Truth für die Public-Nav-Items (06.R34).
 * Wird von PublicHeader (Desktop-Nav + Mobile-Drawer) genutzt;
 * Labels laufen über i18n (`nav.<tKey>`).
 *
 * 02.N1: 4–6 Kernpunkte — Home ist bewusst NICHT gelistet
 * (das Logo verlinkt auf die Startseite).
 */

export type PublicNavItem = {
  href: string;
  tKey: 'menu' | 'laputia' | 'events' | 'about' | 'gallery' | 'contact';
};

export const PUBLIC_NAV_ITEMS: PublicNavItem[] = [
  { href: '/speisekarte', tKey: 'menu' },
  { href: '/la-putia', tKey: 'laputia' },
  { href: '/events', tKey: 'events' },
  { href: '/ueber-uns', tKey: 'about' },
  { href: '/galerie', tKey: 'gallery' },
  { href: '/kontakt', tKey: 'contact' },
];

export type FooterLegalItem = { href: string; label: string };

export const FOOTER_LEGAL_ITEMS: FooterLegalItem[] = [
  { href: '/impressum', label: 'Impressum' },
  { href: '/datenschutz', label: 'Datenschutz' },
  { href: '/agb', label: 'AGB' },
];
